import { action } from '@ember/object';
import Component from '@glimmer/component';

export default class ModalComponent extends Component {
  constructor() {
    super(...arguments);
    // console.log(this.args);
  }

  @action
  toggleModal(val) {
    this.args?.toggleModal?.(val);
  }
}
